
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.953 8.54L4.75 14.47v6.402a.625.625 0 00.625.625l4.377-.011a.625.625 0 00.622-.625v-3.739a.625.625 0 01.625-.625h2.5a.625.625 0 01.625.625v3.736a.625.625 0 00.625.627l4.375.012a.625.625 0 00.625-.625v-6.406l-7.2-5.928a.476.476 0 00-.598 0zm11.376 4.031L20.063 9.88V4.47A.469.469 0 0019.594 4h-2.187a.469.469 0 00-.469.469v2.836l-3.497-2.877a1.875 1.875 0 00-2.383 0L1.17 12.57a.468.468 0 00-.062.66l.996 1.211a.47.47 0 00.66.064l9.189-7.568a.476.476 0 01.597 0l9.189 7.568a.472.472 0 00.518.053.47.47 0 00.142-.116l.996-1.21a.469.469 0 00-.066-.662z","fill":"#282E3E"}})])
          )
        }
      }
    